<button mat-raised-button color="primary" (click)="loginWithRedirect()">
    Log in
</button>
